var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bill-shell',[_c('section',{staticClass:"py-5 pb-3 bg-white"},[_c('ViewTokenContent')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }